// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreOrder = (client) => ({
    /**
     * `GET /store/orders/:id/fulfillments/:fulfillment_id/fulfillment-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListOrderFulfillmentDocuments
     * @source packages/medusa-plugin-fulfillment-documents/src/api/store/orders/[id]/fulfillments/[fulfillment_id]/fulfillment-documents/route.ts
     */
    listFulfillmentsFulfillmentDocuments: (id, fulfillmentId, query, headers) => client.fetch(buildPath("/store/orders/:id/fulfillments/:fulfillment_id/fulfillment-documents", [id, fulfillmentId]), { method: "GET", query, headers }),
});
//# sourceMappingURL=orders.js.map